var preloader = function (dom, display) {
    if(display){
        dom.find('.preloader').removeClass('hidden');
    }else{
        dom.find('.preloader').addClass('hidden');
    }
}

export default preloader;


// WEBPACK FOOTER //
// ./resources/assets/js/functions/preloader.js